import api from './api';
import { IFormularioAjuste, IItemAjuste } from '../interfaces/AjusteInventario';

const ajusteInventarioService = {
    // Obtener el siguiente número de formulario
    getNextNroFormulario: async (tipo: string) => {
        const response = await api.get('/api/ajustes/nextNumber', { params: { tipo } });
        return response.data;
    },

    // Crear un nuevo ajuste de inventario
    createAjuste: async (formulario: IFormularioAjuste, items: IItemAjuste[], tipo: string) => {
        // Preparar el payload según el nuevo formato del endpoint POST /api/Ajustes
        const fecha = formulario.fechaEmision instanceof Date 
            ? formulario.fechaEmision.toISOString() 
            : (typeof formulario.fechaEmision === 'string' 
                ? formulario.fechaEmision 
                : new Date().toISOString());

        const payload = {
            fecha: fecha,
            nroSuc: formulario.nroSuc || 0,
            descripcion: formulario.descripcion || '',
            nroUbicacionOrigen: formulario.nroUbicacionOrigen || 0,
            nroUbicacionDestino: formulario.nroUbicacionDestino || 0,
            items: items.map(item => ({
                codigoArticulo: item.codigoArticulo || '',
                descripcion: item.descripcion || '',
                cantidad: Number(item.cantidad) || 0,
                costo: Number(item.costo) || 0,
                notas: item.notas || ''
            }))
        };

        console.log('📤📤📤 POST /api/Ajustes - PAYLOAD COMPLETO:', JSON.stringify(payload, null, 2));
        console.log('📤 POST /api/Ajustes - Parámetro tipo:', tipo);
        console.log('📤 POST /api/Ajustes - Verificación de ubicaciones:', {
            nroUbicacionOrigen: payload.nroUbicacionOrigen,
            nroUbicacionDestino: payload.nroUbicacionDestino,
            tipoAjuste: tipo,
            esNegativo: tipo === 'negativo' && payload.nroUbicacionDestino === 0
        });
        
        // VERIFICACIÓN CRÍTICA antes de enviar
        if (tipo === 'negativo' && payload.nroUbicacionDestino !== 0) {
            console.error('❌❌❌ ERROR CRÍTICO: Intentando guardar ajuste negativo con nroUbicacionDestino != 0');
            console.error('❌ El backend puede guardarlo incorrectamente como transferencia');
        }
        
        const response = await api.post('/api/Ajustes', payload);
        console.log('📥 POST /api/Ajustes - Respuesta:', response.data);
        console.log('📥 POST /api/Ajustes - Respuesta completa:', JSON.stringify(response.data, null, 2));
        return response.data;
    },

    // Actualizar un ajuste de inventario
    updateAjuste: async (nroFormulario: number, formulario: IFormularioAjuste, items: IItemAjuste[], tipo: string) => {
        const response = await api.put(`/api/ajustes/${nroFormulario}`, { formulario, items }, { params: { tipo } });
        return response.data;
    },

    // Obtener un ajuste por número
    getAjuste: async (nroFormulario: number) => {
        const response = await api.get(`/api/ajustes/${nroFormulario}`);
        return response.data;
    },

    // Obtener lista de ajustes
    getAjustes: async (params: any) => {
        // IMPORTANTE: El backend puede tener filtros que excluyen ajustes negativos
        // Por eso el ajuste se puede obtener por ID pero no aparece en la lista paginada
        // No agregamos parámetros de ordenamiento porque el backend puede no aceptarlos
        // El problema está en el backend, no en el frontend
        console.log('📤 GET /api/ajustes - Parámetros de consulta:', params);
        const response = await api.get('/api/ajustes', { params });
        console.log('📥 GET /api/ajustes - Respuesta:', {
            items: response.data.items?.length || 0,
            totalCount: response.data.totalCount,
            pageNumber: response.data.pageNumber,
            pageSize: response.data.pageSize,
            // Verificar si hay ajustes negativos en la respuesta
            ajustesNegativos: response.data.items?.filter((a: any) => 
                a.nroUbicacionOrigen && a.nroUbicacionOrigen > 0 && 
                (!a.nroUbicacionDestino || a.nroUbicacionDestino === 0)
            ).length || 0
        });
        return response.data;
    },

    // Anular un ajuste
    anularAjuste: async (nroFormulario: number) => {
        const response = await api.delete(`/api/ajustes/${nroFormulario}`);
        return response.data;
    },

    // Obtener reporte PDF
    getReporte: async (nroFormulario: number) => {
        const response = await api.get(`/api/ajustes/${nroFormulario}/pdf`, {
            responseType: 'blob'
        });
        return response.data;
    },

    registrarMovStockHistorico: async (data: {
        idformulario: number;
        codigoArticulo: string;
        tipoAjuste: string;
        cantidad: number;
        deposito: number;
        nroSuc: number;
        esEgreso: boolean;
        nroItems: number;
        letra: string;
        nroComprobante: number;
    }) => {
        const response = await api.post('/api/ajustes/registrarMovStockHistorico', data);
        return response.data;
    }
};

export default ajusteInventarioService; 